import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { FooterActionComponent } from '../../../../shared/components/footer-action/footer-action.component';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { AlertCardComponent } from '../../../../shared/components/alert-card/alert-card.component';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { ConfigFciService } from '../../../../shared/services/apis/motor-fiscal/config-fci.service';
import { ConfigFciRequest } from '@shared/services/requests/motor-fiscal/config-fci.request';
import { ConfigFciResponse } from '@shared/services/responses/motor-fiscal/config-fci.response';

@Component({
  selector: 'app-config-fci',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatSlideToggleModule,
    HeaderComponent,
    FooterActionComponent,
    LoadingBoxComponent,
    AlertCardComponent,
  ],
  templateUrl: './config-fci.component.html',
  styleUrls: ['./config-fci.component.css'],
})
export class ConfigFciComponent implements OnInit {
  public moduloEnum = ModuloEnum.Configuracoes;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Suprimentos;
  public form: FormGroup;
  public isLoading = false;
  public isSaving = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private alertService: AlertService,
    private configFciService: ConfigFciService,
  ) {
    this.form = this.formBuilder.group({
      isVincularFciNotaFiscal: [false],
    });
  }

  public ngOnInit(): void {
    this.loadConfig();
  }

  public voltar(): void {
    this.router.navigate(['/configuracoes/suprimentos']);
  }

  public salvar(): void {
    const request: ConfigFciRequest = {
      isVincularFciNotaFiscal: this.form.get('isVincularFciNotaFiscal')?.value ?? false,
    };

    this.isSaving = true;

    this.configFciService.put(request).subscribe({
      next: response => {
        this.isSaving = false;
        if (response.isError) {
          this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
          return;
        }

        this.alertService.show('Sucesso', 'Configurações salvas com sucesso!', AlertType.success);
        this.voltar();
      },
      error: () => {
        this.isSaving = false;
        this.alertService.show('Aviso', 'Falha na comunicação com o servidor.', AlertType.warning);
      },
    });
  }

  private loadConfig(): void {
    this.isLoading = true;

    this.configFciService.get().subscribe({
      next: (response: ConfigFciResponse) => {
        this.isLoading = false;
        if (response.isError) {
          this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
          return;
        }

        const configuracao = response.configuracaoFci;
        if (configuracao) {
          this.form.patchValue({
            isVincularFciNotaFiscal: configuracao.isVincularFciNotaFiscal,
          });
        }
      },
      error: () => {
        this.isLoading = false;
        this.alertService.show('Aviso', 'Falha na comunicação com o servidor.', AlertType.warning);
      },
    });
  }
}
